;(function ($) {
    $.fn.naturataProductsFilter = function () {
        return $(this).each(function () {
            var container = $(this);
            var filterContainer = container.find('[data-filters]');
            var filterInputs = container.find('[data-product-filter]');
            var products = container.find('li[data-filtercategories]');
            var toggleFilters = container.find('[data-filters-toggle]');
            var filtersReset = container.find('[data-filters-reset]');
            var toggleFilterCategory = container.find('[data-filters-toggle-category]');
            toggleFilters.on('click', function (e) {
                console.log('clicked');
                console.log(filterContainer);
                e.preventDefault();
                filterContainer.toggleClass('open');
            });
            filtersReset.on('click', function (e) {
                e.preventDefault();
                filterInputs.removeAttr('checked').prop("checked", false);
                applyFilters();
            });
            toggleFilterCategory.on('click', function (e) {
                e.preventDefault();
                $(this).parents('.filters__content__category').toggleClass('open');
            });
            var applyFilters = function () {
                var checkedFilterInputs = filterInputs.filter(':checked');
                console.log('applyFilters');
                filtersReset.hide();
                products.show();
                if (checkedFilterInputs.length == 0) {
                    return;
                }
                filtersReset.show();
                products.each(function () {
                    var product = $(this);
                    checkedFilterInputs.each(function () {
                        var filterCategory = $(this).data('productFilter');
                        if ((',' + product.data('filtercategories') + ',').indexOf(',' + filterCategory + ',') == -1) {
                            product.hide();
                            return false;
                        }
                    });
                });
            };
            applyFilters();
            filterInputs.on('change', applyFilters);
        });
    };
    $(function () {
        $('[data-productlist]').naturataProductsFilter();
    });
})(jQuery);
